<template>
  <div class="obituary-single__funeral-program-image-wrapper has-pages">
    <div v-if="imageUrl && pages" class="slider">
      <div ref="slider" class="slider-container">
        <div
          v-for="i in pages"
          ref="sliderItem"
          :key="`slider-item-${i}`"
          class="slider-item"
          :class="`slider-item-${i}`"
        >
          <ix-img
            :src="imageUrl"
            width="370"
            loading="lazy"
            :imgix-params="{
              w: 370,
              page: pages ? i : null,
            }"
          />
        </div>
      </div>

      <div class="slider-info">
        <span v-text="paginationText" />
        <button
          :aria-label="texts.openProgramInFullScreen"
          class="btn icon"
          @click="toggleModal"
        >
          <svg class="icon icon--small"><use href="#arrows-maximize" /></svg>
        </button>
      </div>

      <div class="slider-controls">
        <button
          :aria-label="texts.previousPage"
          class="btn icon"
          :disabled="prevDisabled"
          @click="previous"
        >
          <svg class="icon"><use href="#chevron-left" /></svg>
        </button>
        <button
          :aria-label="texts.nextPage"
          class="btn icon"
          :disabled="nextDisabled"
          @click="next"
        >
          <svg class="icon"><use href="#chevron-right" /></svg>
        </button>
      </div>
    </div>
    <funeral-program-modal
      :is-open="modalIsOpen"
      :pages="pages"
      :image-url="imageUrl"
      :toggle-modal="(bool) => toggleModal(bool)"
    />
  </div>
</template>

<script>
import debounce from 'lodash-es/debounce';
import { buildUrl } from 'vue-imgix';
import FuneralProgramModal from './FuneralProgramModal.vue';
import { mapState } from 'vuex';

export default {
  name: 'FuneralProgramPages',

  components: {
    FuneralProgramModal,
  },

  data() {
    return {
      imageUrl: this.$mountEl.dataset.funeralProgramImage,
      activePage: 1,
      pages: 1,
      modalIsOpen: false,
      texts: theme_vars.funeralProgramSlider,
    };
  },

  computed: {
    ...mapState('orders', ['isLoading', 'order']),

    itemSize() {
      return this.$refs.sliderItem[this.activePage - 1].clientWidth;
    },

    nextDisabled() {
      return this.activePage === this.pages;
    },

    prevDisabled() {
      return this.activePage === 1;
    },

    paginationText() {
      return `${this.activePage}/${this.pages}`;
    },
  },

  created() {
    this.maybeAddPage();
  },

  mounted() {
    this.$refs.slider.addEventListener('scroll', this.checkActivePage);
  },

  beforeUnmount() {
    this.$refs.slider.removeEventListener('scroll', this.checkActivePage);
  },

  methods: {
    async maybeAddPage() {
      const page = this.pages ? this.pages + 1 : 0;
      const src = buildUrl(this.imageUrl, {
        page,
        w: 1,
        h: 1,
        q: 1,
        fm: 'webp',
      });

      const response = await fetch(src).then((response) => !!response.ok);

      if (!response) {
        return;
      }

      this.pages = page;
      this.maybeAddPage();
    },

    next() {
      this.scrollBy(this.itemSize);
    },

    previous() {
      this.scrollBy(-this.itemSize);
    },

    scrollBy(left) {
      this.$refs.slider.scrollBy({
        top: 0,
        left,
        behavior: 'smooth',
      });
    },

    checkActivePage: debounce(function () {
      const index = Math.round(
        (this.$refs.slider.scrollLeft / this.$refs.slider.scrollWidth) *
          this.pages
      );
      this.activePage = index + 1;
    }, 100),

    toggleModal(bool = true) {
      this.modalIsOpen = bool;
    },
  },
};
</script>
